module.exports = __webpack_public_path__ + "static/media/profileCoverImage.e302562c.png";